import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { EmailLoginIcon } from 'icons/login/EmailLoginIcon';
import { KakaoLoginIcon } from 'icons/login/KakaoLoginIcon';
import { NaverLoginIcon } from 'icons/login/NaverLoginIcon';
import { TwitterLoginIcon } from 'icons/login/TwitterLoginIcon';
import { GoogleLoginIcon } from 'icons/login/GoogleLoginIcon';
import { AppleLoginIcon } from 'icons/login/AppleLoginIcon';
import { ButtonType } from 'constants/button';

export const LoginButtonType = {
  [SsoType.Kakao]: ButtonType.KakaoLogin,
  [SsoType.Naver]: ButtonType.NaverLogin,
  [SsoType.Twitter]: ButtonType.TwitterLogin,
  [SsoType.Google]: ButtonType.GoogleLogin,
  [SsoType.Apple]: ButtonType.AppleLogin,
  [SsoType.Ridi]: ButtonType.RidiLogin,
  [SsoType.Email]: ButtonType.Primary,
};

export const LoginIcon = {
  [SsoType.Kakao]: KakaoLoginIcon,
  [SsoType.Naver]: NaverLoginIcon,
  [SsoType.Twitter]: TwitterLoginIcon,
  [SsoType.Google]: GoogleLoginIcon,
  [SsoType.Apple]: AppleLoginIcon,
  [SsoType.Ridi]: AppleLoginIcon,
  [SsoType.Email]: EmailLoginIcon,
};
